<template>
    <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" :width="width" :height="height" version="1.1"
         style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
         viewBox="0 0 49 57"
         xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Слой_x0020_1">
            <metadata id="CorelCorpID_0Corel-Layer"></metadata>
            <path class="frame-fill frame-stroke" :class="{'frame-active': selected}" d="M14 2c4,0 9,-1 12,-1 9,0 18,-1 21,3 4,5 2,15 -4,26 -8,14 -3,29 -26,27 -8,-2 -9,-7 -10,-16 -1,-7 -4,-12 -5,-17 -2,-15 1,-22 13,-22z"></path>
        </g>
    </svg>
</template>

<script>
    import {implantMixin} from '@/mixins/implant.js'

    export default {
        mixins: [implantMixin]

    }
</script>

<style scoped>

</style>
